import { render, staticRenderFns } from "./TicketsSettingsTable.vue?vue&type=template&id=11354690&lang=pug&"
import script from "./TicketsSettingsTable.vue?vue&type=script&lang=js&"
export * from "./TicketsSettingsTable.vue?vue&type=script&lang=js&"
import style0 from "./TicketsSettingsTable.vue?vue&type=style&index=0&id=11354690&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports